import { defineStore } from 'pinia';

import { ChatBridgeInterface } from '#ui-shared/stores/app-bridge/chat-bridge';
import { NoraBridgeInterface } from '#ui-shared/stores/app-bridge/nora-bridge';

/**
 * Bridge store for communication between nora-ui and chat-ui.
 * Provides a shared interface for cross-app interactions without event-driven complexity.
 */
export const useAppBridgeStore = defineStore('appBridgeStore', () => {
  const chat = new ChatBridgeInterface();
  const nora = new NoraBridgeInterface();

  return {
    chat,
    nora,
  };
});
